import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "./admin.css";
import { useAuth } from "../auth/AuthContext";

export default function AdminLayout() {
  const nav = useNavigate();
  const { user, loading, hasRole, logout } = useAuth();

  const doLogout = () => {
    logout();
    nav("/login");
  };

  if (loading) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  return (
    <div className="admin">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="brand">
          <div className="brandLogo">S</div>
          <div>
            <div className="brandName">Admin Panel</div>
            {user && (
              <div className="brandMeta">
                <div className="brandUser">{user.username}</div>
                <div className="brandRole">{(user.roles || []).join(", ")}</div>
              </div>
            )}
          </div>
        </div>

        <nav className="nav">
          {/* hamı görür */}
          <NavLink
            to="/dashboard"
            className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
          >
            <span className="dot" />
            Dashboard
          </NavLink>

          {/* ✅ USER + ADMIN + SUPERADMIN: Slider */}
          {hasRole("user", "admin", "superadmin") && (
            <>
              <div className="navSection">BASIC</div>

              <NavLink
                to="/sliders"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Slider
              </NavLink>
            </>
          )}

          {/* ✅ ADMIN + SUPERADMIN: digər content */}
          {hasRole("admin", "superadmin") && (
            <>
              <div className="navSection">CONTENT</div>

              <NavLink
                to="/news"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Xəbərlər
              </NavLink>

              <NavLink
                to="/about-text"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Şirkət haqqında
              </NavLink>

              <NavLink
                to="/products"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Məhsullar
              </NavLink>

              <NavLink
                to="/orders"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Sifarişlər
              </NavLink>

              <NavLink
                to="/contacts"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Əlaqə (İsmarıc)
              </NavLink>
            </>
          )}

          {/* ✅ SUPERADMIN: Users */}
          {hasRole("superadmin") && (
            <>
              <div className="navSection">SECURITY</div>

              <NavLink
                to="/users"
                className={({ isActive }) => `navItem ${isActive ? "active" : ""}`}
              >
                <span className="dot" />
                Users
              </NavLink>
            </>
          )}
        </nav>
      </aside>

      {/* Main */}
      <main className="main">
        <header className="topbar">
          <div className="topbarLeft" />

          <div className="topbarRight">
            {user && (
              <div className="topbarUser">
                <span className="topbarUserName">{user.username}</span>
                <span className="topbarUserRole">
                  {(user.roles || []).join(", ")}
                </span>
              </div>
            )}

            <button className="topbarBtn" onClick={doLogout}>
              Logout
            </button>
          </div>
        </header>

        <section className="content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}
